import React from "react";
import {useParams} from "react-router-dom";
import {useRecoilValue} from "recoil";
import {tokenSelector} from "../../../Recoil/Atom/authState";
import {useGetItemQuery} from "../../../hooks/useQueryHooks";
import MWProgress from "../../../components/MWProgress";
import SubTitle from "../../../components/SubTitle";
import {SubMenuGroup} from "../../../styledComponents/StyledListContainer";
import {Box} from "@mui/material";
import MWCaption from "../../../components/MWCaption";
import {FormContents} from "../../../styledComponents/StyledCreateForm";
import {ResponseItem} from "../../../models/clientModels/interfaces/Response";
import ReportIcon from "@mui/icons-material/Report";
import * as examApi from "../../../api/educationApi/examApi";
const ExamScore = () => {
  const {id} = useParams();
  const tokenState = useRecoilValue(tokenSelector);

  const {data: score, isLoading} = useGetItemQuery<ResponseItem<string>>({
    key: ["ExamScore", id],
    api: () => examApi.getScore({token: tokenState, id: parseInt(id!)}),
  });
  if (isLoading) <MWProgress />;
  return (
    <React.Fragment>
      <SubTitle
        subTitle="응시결과
"
      ></SubTitle>
      <SubMenuGroup></SubMenuGroup>
      <Box>
        <MWCaption title={"채점표"} color="#01579B" icon={<ReportIcon />} />
        <FormContents container rowSpacing={2} justifyContent="center">
          <div dangerouslySetInnerHTML={{__html: score?.item!}}></div>
        </FormContents>
      </Box>
    </React.Fragment>
  );
};

export default ExamScore;
